module.exports = __webpack_public_path__ + "hero-d3aec207.png";